<template>
	<div class="map-part">
		<title1 title="双碳指标" subTitle="Double Carbon Index" />
		<div class="contion">
			<div class="item">
				<div class="parents_box">
					<img class="itemImg" src="@/assets/images/index/double_title.png" />
					<div class="item_box">
						<p class="p_1 mt-10">本月平均能耗(度/km)</p>
						<div class="p_box mt-10">
							<div class="p_left">
								{{ stationData.cur_month_energy_consumption }}
							</div>
							<div class="p_right">
								<p class="p_2">较上月</p>
								<p class="p_3">{{ stationData.compare_last_month_energy_consumption }}</p>
							</div>
						</div>
					</div>
				</div>
				<div class="parents_box">
					<img class="itemImg" src="@/assets/images/index/double_title.png" />
					<div class="item_box">
						<p class="p_1">本月平均度电里程(km/度)</p>
						<div class="p_box">
							<div class="p_left">
								{{ stationData.cur_month_mileage_per_kwh }}
							</div>
							<div class="p_right">
								<p class="p_2">较上月</p>
								<p class="p_3">{{ stationData.compare_last_month_mileage_per_kwh }}</p>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="box ">
				<divBox title="平均能耗趋势">
					<myEchart v-if="showcdata1" :id="'averageUsePower'" :options="cdata1" />
				</divBox>
			</div>
			<div class="box1 mt-30">
				<divBox title="平均度电里程">
					<myEchart v-if="showcdata2" :id="'averageEleMile'" :options="cdata2" />
				</divBox>
			</div>
			<div class="box1 mt-30">
				<divBox title="SOC仿真平均能耗">
					<myEchart v-if="showcdata3" :id="'socAverageUsePower'" :options="cdata3" />
				</divBox>
			</div>
		</div>
	</div>
</template>

<script>
import infoList from "../infoList";
import divBox from "./divbox2";
import myEchart from "../charts/echarts";
import { dataInterface } from "@/api/dataInterfaceApi";
import title1 from '@/views/exposition/components/title1'
import * as echarts from "echarts5";

export default {
	components: {
		myEchart,
		divBox,
		infoList,
		title1
	},
	data() {
		return {
			bigtitle: {
				CHN: "双碳指标",
				ENG: "Traffic indicators",
			},
			showcdata1: false,
			// title:"平均能耗趋势",
			cdata1: {
				backgroundColor: "rgba(0, 0, 0, 0.1)",
				xAxis: {
					type: "category",
					boundaryGap: false,
					data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
				},
				yAxis: {
					type: "value",
					splitLine: false,
				},
				legendData: [{
						name: "新增数",
						icon: "roundRect",
					},
					{
						name: "活跃数",
						icon: "roundRect",
					},
				],
				series: [{
					name: "平均耗能（度/km）",
					type: "line",
					areaStyle: {},
					smooth: true,
					areaStyle: {
						normal: {
							color: {
								type: "linear",
								x: 0,
								y: 0,
								x2: 0,
								y2: 1,
								colorStops: [{
										offset: 0.1,
										color: "rgba(25, 104, 255,0.42)", // 0% 处的颜色
									},
									{
										offset: 0.9,
										color: "rgba(61, 230, 255,0)", // 100% 处的颜色
									},
								],
								globalCoord: false, // 缺省为 false
							},
						},
					},
					itemStyle: {
						normal: {
							color: "#36A1FF", //改变折线点的颜色
							lineStyle: {
								color: "#36A1FF", //改变折线颜色
							},
						},
					},
				}, ],
			},
			showcdata2: false,
			// title:"平均度电里程",
			cdata2: {
				title: {
					text: "km",
				},
				backgroundColor: "rgba(0, 0, 0, 0.1)",
				xAxis: {
					type: "category",
					boundaryGap: false,
					data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
				},
				yAxis: {
					type: "value",
					splitLine: false,
				},
				legendData: [{
						name: "新增数",
						icon: "roundRect",
					},
					{
						name: "活跃数",
						icon: "roundRect",
					},
				],
				series: [{
					name: "平均度电里程（km/度）",
					type: "line",
					areaStyle: {},
					smooth: true,
					areaStyle: {
						normal: {
							color: {
								type: "linear",
								x: 0,
								y: 0,
								x2: 0,
								y2: 1,
								colorStops: [{
										offset: 0.1,
										color: "rgba(25, 104, 255,0.42)", // 0% 处的颜色
									},
									{
										offset: 0.9,
										color: "rgba(61, 230, 255,0)", // 100% 处的颜色
									},
								],
								globalCoord: false, // 缺省为 false
							},
						},
					},
					itemStyle: {
						normal: {
							color: "#36A1FF", //改变折线点的颜色
							lineStyle: {
								color: "#36A1FF", //改变折线颜色
							},
						},
					},
				}, ],
			},
			showcdata3: false,
			// title:"车辆新增及活跃趋势",
			cdata3: {
				title: {
					text: "度/km",
				},
				backgroundColor: "rgba(0, 0, 0, 0.1)",
				xAxis: {
					type: "category",
					boundaryGap: false,
					data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
				},
				tooltip: {
					trigger: "axis",
					formatter: function(params) {
						return (
							"SOC：" +
							params[0].axisValue +
							"<br>" +
							"平均能耗（度/min）：" +
							params[0].data
						);
					},
				},
				yAxis: {
					type: "value",
					splitLine: false,
				},
				legendData: [{
						name: "新增数",
						icon: "roundRect",
					},
					{
						name: "活跃数",
						icon: "roundRect",
					},
				],
				series: [{
					data: [820, 932, 901, 934, 1290, 1330, 1320],
					type: "line",
					smooth: true,
					areaStyle: {
						normal: {
							color: {
								type: "linear",
								x: 0,
								y: 0,
								x2: 0,
								y2: 1,
								colorStops: [{
										offset: 0.1,
										color: "#2B7F81", // 0% 处的颜色
									},
									{
										offset: 0.9,
										color: "#133738", // 100% 处的颜色
									},
								],
								globalCoord: false, // 缺省为 false
							},
						},
					},
					itemStyle: {
						normal: {
							color: "#50FAFE", //改变折线点的颜色
							lineStyle: {
								color: "#50FAFE", //改变折线颜色
							},
						},
					},
				}, ],
			},
			stationData: {},
		};
	},
	props: {
		// cdata: {
		//   type: Object,
		//   default: () => ({}),
		// },
	},
	watch: {},
	mounted() {
		//获取平均能耗趋势
		this.getBattery1();
		//获取平均度电里程
		this.getBattery2();
		// SOC仿真平均能耗
		this.getBattery3();
		// 双碳指标
		this.getDouble();
	},
	methods: {
		// 刷新接口需要每个子组件封装一个getData();
		getData(data) {
			console.log("sf123123123123123123123", data);
		},
		//获取平均能耗趋势
		getBattery1() {
			let params = {
				enCode: "per_vehicle-平均度电能耗",
				"@VEHICLE_VIN": localStorage.getItem("newVehicleNum") ?
					localStorage.getItem("newVehicleNum") :
					"LDP31B967MG929008",
			};
			dataInterface
				.dataFaceApi(params)
				.then((res) => {
					if (res) {
						let data = [];
						let xAxis = [];
						res.forEach((item) => {
							xAxis.push(item.cur_date);
							data.push(item.energy_consuption_per_mileage || 0);
						});
						this.cdata1.xAxis.data = xAxis;
						this.cdata1.series[0].data = data;
						this.showcdata1 = true;
					}
				})
				.catch((err) => {
					console.log(err);
				});
		},
		//获取平均度电里程
		getBattery2() {
			let params = {
				enCode: "per_vehicle-平均度电里程",
				"@VEHICLE_VIN": localStorage.getItem("newVehicleNum") ?
					localStorage.getItem("newVehicleNum") :
					"LDP31B967MG929008",
			};
			dataInterface
				.dataFaceApi(params)
				.then((res) => {
					if (res) {
						let data = [];
						let xAxis = [];
						res.forEach((item) => {
							xAxis.push(item.cur_date);
							data.push(item.mileage_per_kwh || 0);
						});
						this.cdata2.xAxis.data = xAxis;
						this.cdata2.series[0].data = data;
						this.showcdata2 = true;
					}
				})
				.catch((err) => {
					console.log(err);
				});
		},
		// SOC仿真平均能耗
		getBattery3() {
			let params = {
				enCode: "per_vehicle-soc平均能耗",
				"@VEHICLE_VIN": localStorage.getItem("newVehicleNum") ?
					localStorage.getItem("newVehicleNum") :
					"LDP31B967MG929008",
			};
			dataInterface
				.dataFaceApi(params)
				.then((res) => {
					if (res) {
						let data = [];
						let xAxis = [];
						res.forEach((item) => {
							xAxis.push(item.soc);
							data.push(item.energy_consumption);
						});
						this.cdata3.xAxis.data = xAxis;
						this.cdata3.series[0].data = data;
						this.showcdata3 = true;
					}
				})
				.catch((err) => {
					console.log(err);
				});
		},
		// 双碳指标
		getDouble() {
			let params = {
				enCode: "per_vehicle-双碳指标",
				"@VEHICLE_VIN": localStorage.getItem("newVehicleNum") ?
					localStorage.getItem("newVehicleNum") :
					"LDP31B967MG929008",
			};
			dataInterface
				.dataFaceApi(params)
				.then((res) => {
					if (res) {
						console.log(res, "双碳指标");
						this.stationData = res[0] || {};
					}
				})
				.catch((err) => {
					console.log(err);
				});
		},
	},
};
</script>

<style lang="scss" scoped>
// @import './part.scss';
@import '../scss/chd-com.scss';

.p_1 {
	font-size: 14px;
}

.p_2 {
	font-size: 13px;
	transform: scale(0.5);
}

.p_3 {
	font-size: 40px;
	transform: scale(0.5);
}

.contion {
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;

	// flex-wrap: wrap;
	// align-content: stretch;
	// justify-content: space-between;
	.item {
		margin: 50px 0 60px 0;
		display: flex;

		.parents_box {
			// padding: 5px 0;
			display: flex;
			align-items: center;

			.itemImg {
				width: auto;
				height: 70px;
			}

			.p_box {
				.p_left {
					font-size: 22px;
					color: #03b9bd;
				}

				.p_right {
					display: flex;
					flex-direction: column;

					p {
						margin: 0;
						padding: 0;
						font-size: 18px;
					}

					p:nth-child(2) {
						height: 0;
						margin: 0;
						padding: 0;
						color: #ffd15c;
					}
				}

				display: flex;
				flex-direction: row;
				justify-content: space-around;
				// align-items: center;
			}
		}
	}
}

.box {
	width: 100%;
	height: 370px;
}

.box1 {
	width: 430px;
	height: 370px;
}
</style>
